var staticDayTime = 86400000

module.exports = staticDayTime



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/static/staticDayTime.js
// module id = 145
// module chunks = 106